import { BuildRulesetQuery } from '../../../interfaces/Rulesets';
import { extractJsonFieldSql } from '../../extractJsonFieldSql';

export const selectFields_ruleset1_PD_QCV: string = `*`;

export const order_ruleset1_PD_QCV  = 'rank DESC, label';

const getAttributes = (rawName: string) => ({
    kvspos1: `$.8681.${rawName}`,
    kvspos2: `$.8682.${rawName}`,
    kvspos3: `$.8683.${rawName}`,
    kvspos4: `$.8684.${rawName}`,
    kvspos5: `$.8685.${rawName}`,
    kvspos6: `$.8686.${rawName}`,
    kvspos7: `$.8687.${rawName}`,
    kvs: `$.14.${rawName}`,
    dpmax: `$.28.${rawName}`,
    line: `$.7266.${rawName}`,
    dn: `$.15.${rawName}`,
});

export const buildQuery_ruleset1_PD_QCV: BuildRulesetQuery = ({
    selectFields,
    rawName,
    filter,
    discontinuedAttr,
    volumetricFlow,
    kvs,
}): [string, string[]] => {
    const attrs = getAttributes(rawName);
    return [`WITH
vpl as (SELECT
    min(cast(kvspos1Attr.value as float)) * 0.6 as vplmin,
    max(cast(kvsAttr.value as float)) * 1.3 as vplmax,
    min(label) as vplLabel,
    lineAttr.value as vplLine
FROM product
         JOIN json_each(${extractJsonFieldSql('attributes', `${attrs.kvspos1}`)}) as kvspos1Attr
         LEFT JOIN json_each(${extractJsonFieldSql('attributes', `${attrs.kvs}`)}) as kvsAttr
         LEFT JOIN json_each(${extractJsonFieldSql('attributes', `${attrs.line}`)}) as lineAttr
WHERE lower(json_extract(attributes, '$.6691.${rawName}')) IN ('["valve"]')
  AND ${extractJsonFieldSql('attributes', `$.${discontinuedAttr}.${rawName}`)} = '["0"]'
GROUP BY vplLine
)
, products_filtered as (SELECT
    ABS(cast(positions.value as float) - bounds.kvs) delta,
    cast(positions.value as float) as pos,
    positions.key as posKey,
    lineAttr.value as line,
    cast(dnAttr.value as float) as DN,
    product.id,
    product.label,
    attributes
FROM product
JOIN bounds
         LEFT JOIN json_each(${extractJsonFieldSql('attributes', `${attrs.dn}`)}) as dnAttr
         LEFT JOIN json_each(${extractJsonFieldSql('attributes', `${attrs.line}`)}) as lineAttr
         CROSS JOIN json_each(json_array(
                ${extractJsonFieldSql('attributes', `${attrs.kvspos1}[0]`)},
                ${extractJsonFieldSql('attributes', `${attrs.kvspos2}[0]`)},
                ${extractJsonFieldSql('attributes', `${attrs.kvspos3}[0]`)},
                ${extractJsonFieldSql('attributes', `${attrs.kvspos4}[0]`)},
                ${extractJsonFieldSql('attributes', `${attrs.kvspos5}[0]`)},
                ${extractJsonFieldSql('attributes', `${attrs.kvspos6}[0]`)},
                ${extractJsonFieldSql('attributes', `${attrs.kvspos7}[0]`)},
                ${extractJsonFieldSql('attributes', `${attrs.kvs}[0]`)}
         )) as positions
WHERE ${filter}
  AND ${extractJsonFieldSql('attributes', `$.7266.${rawName}`)} in ('["Zone valve"]')
ORDER BY delta, pos DESC
)
,user_input as (SELECT cast(? as float) as kvs, cast(? as float) as v100)
,bounds as (SELECT 
                cast(floor(kvs * 0.6 * 10) as float) / 10 as lower,
                round(kvs * 1.2, 1) as upper,
                kvs,
                v100
            FROM user_input)
, data as (SELECT
    first_value(delta) over (partition by label) as delta,
    first_value(posKey) over (partition by label) as posKey,
    first_value(pos) over (partition by label) as pos,
    line,
    id,
    label,
    attributes,
    DN
FROM products_filtered GROUP BY label ORDER BY delta ASC)
, distance as (SELECT
    delta as distance,
    CASE WHEN pos - bounds.kvs > 0 THEN 1 ELSE 0 END as sign,
    line as line
FROM data JOIN bounds
ORDER BY distance, sign DESC)
, best as (SELECT
    first_value(distance) over (partition by line) as bestDistance,
    first_value(sign) over (partition by line) as bestSign,
    line as bestLine
FROM distance
GROUP BY line)
, selected as (SELECT
        vpl1.vplLabel is not null and posKey = 0 as isFirst,
        cast(kvsAttr.value as float ) as currKvs,
        cast(dpmaxAttr.value as float) as dpmax,
        case when best.bestDistance is not null then 2 else 1 end as rank,
        *
    FROM data
    JOIN bounds
    LEFT JOIN json_each(${extractJsonFieldSql('attributes', `${attrs.kvs}`)}) as kvsAttr
    LEFT JOIN json_each(${extractJsonFieldSql('attributes', `${attrs.dpmax}`)}) as dpmaxAttr
    LEFT JOIN vpl ON vpl.vplLine = data.line or (vpl.vplLine is null and data.line is null)
    LEFT JOIN vpl as vpl1 ON vpl1.vplLabel = data.label
    LEFT JOIN best ON data.line = best.bestline
        AND delta = best.bestDistance
        AND CASE WHEN pos - bounds.kvs > 0 THEN 1 ELSE 0 END = best.bestSign
    WHERE
        CASE WHEN isFirst THEN bounds.kvs between vpl.vplmin AND currKvs 
        ELSE pos between bounds.lower and bounds.upper 
        AND bounds.kvs between vpl.vplmin AND currKvs * 1.3 END
        AND
        CASE WHEN bounds.v100 > 0 AND dpmax > 0 THEN 100 * pow(bounds.v100 / pos, 2) <= dpmax ELSE true END
        AND CASE WHEN DN > 0 AND bounds.v100 > 0 THEN
        bounds.v100 / (3600 * pi() * pow(DN / 1000 / 2, 2)) <= 4
        ELSE true END
)
SELECT ${selectFields} FROM selected
         `,
        [kvs, volumetricFlow]
    ];
}
